module.exports = __webpack_public_path__ + "img/52002737_L.befc75c6.png";